"use client";

import { Pre } from "nextra/components";
import { useRef, useState, type ComponentProps } from "react";
import { emitUsageEvent } from "../lib/umami";
import styles from "./CodeExample.module.css";

export default function CodeExample(props: ComponentProps<typeof Pre>) {
  const container = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState("");
  async function copy() {
    const text = container.current?.querySelector("pre code")?.textContent;
    if (text === undefined || text === null) return;
    try {
      await navigator.clipboard.writeText(text);
      setStatus("Copied");
      emitUsageEvent("example_copy");
    } catch {
      setStatus("Clipboard unavailable");
    }
  }
  return (
    <div ref={container} className={styles.example}>
      {props["data-copy"] === "" && <div className={styles.toolbar} data-pagefind-ignore="all">
        <span role="status" aria-live="polite">{status}</span>
        <button type="button" onClick={copy} aria-label="Copy code">Copy code</button>
      </div>}
      <Pre {...props} data-copy={undefined} />
    </div>
  );
}
